import { render, staticRenderFns } from "./AdminOffers.vue?vue&type=template&id=1527a21b&scoped=true&"
import script from "./AdminOffers.vue?vue&type=script&lang=ts&"
export * from "./AdminOffers.vue?vue&type=script&lang=ts&"
import style0 from "./AdminOffers.vue?vue&type=style&index=0&id=1527a21b&lang=sass&scoped=true&"
import style1 from "./AdminOffers.vue?vue&type=style&index=1&id=1527a21b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1527a21b",
  null
  
)

export default component.exports